import { ActionReducerMap } from "@ngrx/store";
import { rehydrate } from "@obg/ngrx-utils";

import { blogReducer } from "./src/blog/blog.reducer";
import { callingCodeReducer } from "./src/calling-code/calling-code.reducer";
import { campaignReducer } from "./src/campaign/campaign.reducer";
import { customerOfferStateReducer } from "./src/campaign/customer-offer/customer-offer.reducer";
import { cashDeskReducer } from "./src/cash-desk/cash-desk.reducer";
import { commonContentReducer } from "./src/common-content/common-content.reducer";
import { cookieNoticeReducer } from "./src/cookie-notice/cookie-notice.reducer";
import { countryReducer } from "./src/country/country.reducer";
import { customerAssessmentsReducer } from "./src/customer-assessments/customer-assessments.reducer";
import { cookieConsentReducer } from "./src/data-protection/cookie-consent/cookie-consent.reducer";
import { dataProtectionReducer } from "./src/data-protection/data-protection.reducer";
import { marketingSettingsReducer } from "./src/data-protection/marketing-settings/marketing-settings.reducer";
import { geoFencingReducer } from "./src/geofencing/geofencing.reducer";
import { homeContentWidgetReducer } from "./src/home-content-widget/home-content-widget.reducer";
import { iauiBettingLimitReducer } from "./src/iaui-betting-limit/iaui-betting-limit.reducer";
import { iauiVerificationReducer } from "./src/iaui-verification/iaui-verification.reducer";
import { depositThresholdReducer } from "./src/kcy/deposit-threshold/deposit-threshold.reducer";
import { loyaltyContentReducer } from "./src/loyalty/loyalty-content/loyalty-content.reducer";
import { loyaltyReducer } from "./src/loyalty/loyalty.reducer";
import { nationalDataReducer } from "./src/nationaldata/national-data.reducer";
import { nationalityReducer } from "./src/nationality/nationality.reducer";
import { occupationsReducer } from "./src/occupations/occupations.reducer";
import { omsReducer } from "./src/oms/oms.reducer";
import { personalDataReducer } from "./src/personal-data/personal-data.reducer";
import { productLinkReducer } from "./src/product-link/product-link.reducer";
import { regionReducer } from "./src/region/region.reducer";
import { balanceLimitReducer } from "./src/responsible-gaming/balance-limit/balance-limit.reducer";
import { bettingLimitReducer, netLossConfirmationReducer } from "./src/responsible-gaming/betting-limit";
import { netlossLimitReducer } from "./src/responsible-gaming/betting-limit/netloss-limit/netloss-limit.reducer";
import { depositLimitCalculatorReducer } from "./src/responsible-gaming/deposit-limit-calculator/deposit-limit-calculator.reducer";
import { loginLimitProgressReducer, loginLimitReducer } from "./src/responsible-gaming/login-limit/login-limit.reducer";
import { logoutCooldownLimitReducer } from "./src/responsible-gaming/logout-cooldown-limit/logout-cooldown-limit.reducer";
import { multiSessionLimitReducer } from "./src/responsible-gaming/multi-session-limit/multi-session-limit.reducer";
import { zhhSessionLimitReducer } from "./src/responsible-gaming/zhh-session-limit/zhh-session-limit.reducer";
import { rewardReducer } from "./src/reward/reward.reducer";
import { smsNotificationSettingsReducer } from "./src/sms-notification-settings/sms-notification-settings.reducer";
import { CommonState } from "./src/state";
import { supportReducer } from "./src/support/support.reducer";
import { termsAndConditionsReducer } from "./src/terms-and-conditions/terms-and-conditions.reducer";
import { twoFactorAuthReducer } from "./src/two-factor-auth/two-factor-auth.reducer";

export { AccountSettingsAction, ACCOUNT_SETTINGS_ACTION_TYPE } from "./src/account-settings/account-settings.action";
export { AccountSettingsConfigService } from "./src/account-settings/account-settings.config";
export { ACCOUNT_SETTINGS_MESSAGE_CONTEXT } from "./src/account-settings/account-settings.const";
export { AccountSettingPhoneValidation } from "./src/account-settings/account-settings.model";
export { ChangePasswordModel } from "@obg/ngx.common/types";
export { AccountSettingsSelector } from "./src/account-settings/account-settings.selector";
export { AffiliateConfigService } from "./src/affiliate/affiliate.config";
export { AffiliateService, ClientAffiliateService } from "./src/affiliate/affiliate.service";
export { AlternativeMainPageConfig } from "./src/alternative-main-page/alternative-main-page.config";
export { AlternativeMainPageGuard } from "./src/alternative-main-page/alternative-main-page.guard";
export { AppDownloadConfigService } from "./src/app-download/app-download.config";
export { AppDownloadService } from "./src/app-download/app-download.service";
export { AppLifeCycleAction, APP_LIFE_CYCLE_ACTION_TYPE } from "./src/app-lifecycle/app-lifecycle.action";
export { BlogAction, BLOG_ACTION_TYPE } from "./src/blog/blog.action";
export { BlogConfigService } from "./src/blog/blog.config";
export { BlogPost } from "./src/blog/blog.model";
export { blogReducer } from "./src/blog/blog.reducer";
export { BlogSelector } from "./src/blog/blog.selector";
export { BlogService } from "./src/blog/blog.service";
export { GetCallingCodeResponse } from "./src/calling-code/calling-code.model";
export { callingCodeReducer } from "./src/calling-code/calling-code.reducer";
export { CallingCode } from "./src/calling-code/calling-code.model";
export { CallingCodeSelector } from "./src/calling-code/calling-code.selector";
export { CampaignAction, CAMPAIGN_ACTION_TYPE } from "./src/campaign/campaign.action";
export { CampaignConfigService } from "./src/campaign/campaign.config";
export { CAMPAIGN_MESSAGE_CODES, CAMPAIGN_MESSAGE_CONTEXT } from "./src/campaign/campaign.const";
export { CampaignState, FulfillmentCriteria, Offer, OfferState } from "./src/campaign/campaign.model";
export { campaignReducer } from "./src/campaign/campaign.reducer";
export { CampaignSelector } from "./src/campaign/campaign.selector";
export { CampaignService } from "./src/campaign/campaign.service";
export { CommonContentClient } from "./src/content/common-content.client";
export { CommonContentItem } from "./src/common-content/common-content.model";
export { CustomerOfferAction, CUSTOMER_OFFER_ACTION_TYPE } from "./src/campaign/customer-offer/customer-offer.action";
export { CustomerOfferConfigService } from "./src/campaign/customer-offer/customer-offer.config";
export {
	CustomerOffer,
	CustomerOfferState,
	FulfillmentStep,
	NextFulfillmentStep,
	NextFulfillmentSteps,
	OfferStateResponse,
} from "./src/campaign/customer-offer/customer-offer.model";
export { customerOfferStateReducer } from "./src/campaign/customer-offer/customer-offer.reducer";
export { CustomerOfferSelector } from "./src/campaign/customer-offer/customer-offer.selector";
export { CustomerOfferService } from "./src/campaign/customer-offer/customer-offer.service";
export { CashDeskAction, CASH_DESK_ACTION_TYPE } from "./src/cash-desk/cash-desk.action";
export { CASH_DESK_MESSAGE_CONTEXT } from "./src/cash-desk/cash-desk.const";
export { CashDeskEffect } from "./src/cash-desk/cash-desk.effect";
export {
	CashDesk,
	CashDeskContent,
	CashDeskContentItems,
	CashDeskLocationMap,
	CashDeskResponse,
	CashDesksByCity,
	CashDeskState,
	RawCashDesk,
} from "./src/cash-desk/cash-desk.model";
export { cashDeskReducer } from "./src/cash-desk/cash-desk.reducer";
export { CashDeskSelector } from "./src/cash-desk/cash-desk.selector";
export { CashDeskService } from "./src/cash-desk/cash-desk.service";
export {
	Banner,
	BannerContentResponse,
	BannerMetadata,
	BannerResponse,
	BannerResponseItem,
} from "./src/common-content/banner/banner.model";
export { BannerSelector } from "./src/common-content/banner/banner.selector";
export { CommonContentAction, COMMON_CONTENT_ACTION_TYPE } from "./src/common-content/common-content.action";
export { CommonContentParams, CommonContentType } from "./src/common-content/common-content.model";
export { commonContentReducer } from "./src/common-content/common-content.reducer";
export { CommonContentSelector } from "./src/common-content/common-content.selector";
export {
	RegistrationPromotion,
	RegistrationPromotionBadge,
	RegistrationPromotionContentResponse,
	RegistrationPromotionResponseItem,
} from "./src/common-content/registration-promotion/registration-promotion.model";
export {
	MobileRegistrationPromotion,
	MobileRegistrationPromotionContentResponse,
	MobileRegistrationPromotionResponseItem,
} from "./src/common-content/mobile-registration-promotion/mobile-registration-promotion.model";
export { CookieNoticeAction } from "./src/cookie-notice/cookie-notice.action";
export { CookieNoticeEffect } from "./src/cookie-notice/cookie-notice.effect";
export { CookieNoticeState } from "./src/cookie-notice/cookie-notice.model";
export { CookieNoticeSelector } from "./src/cookie-notice/cookie-notice.selector";
export { CountryAction, COUNTRY_ACTION_TYPE } from "./src/country/country.action";
export { State } from "./src/country/country.model";
export { CountryConfigService } from "./src/country/country.config";
export { COUNTRY_MESSAGE_CONTEXT } from "./src/country/country.const";
export { CountryEffect } from "./src/country/country.effect";
export {
	AdministrativeArea,
	AdministrativeAreas,
	Country,
	CountryOrderType,
	CountryResponse,
	CountryState,
	GetCountriesResponse,
	GetCountriesResponseRaw,
} from "./src/country/country.model";
export { countryReducer } from "./src/country/country.reducer";
export { CountrySelector } from "./src/country/country.selector";
export { CountryService } from "./src/country/country.service";
export { CustomerAssessmentsAction } from "./src/customer-assessments/customer-assessments.action";
export { CustomerAssessmentsConfigService } from "./src/customer-assessments/customer-assessments.config";
export {
	CUSTOMER_ASSESSMENTS_MESSAGE_CODES,
	CUSTOMER_ASSESSMENTS_MESSAGE_CONTEXT,
} from "./src/customer-assessments/customer-assessments.const";
export { CustomerAssessmentsDialogService } from "./src/customer-assessments/customer-assessments.dialog";
export {
	AssessmentAnswer,
	AssessmentAvailableAnswer,
	AssessmentForm,
	AssessmentfulfilmentMode,
	AssessmentQuestion,
	AssessmentsFilter,
	AssessmentStatus,
	AssessmentValidator,
	CustomerAssessmentAnswer,
	CustomerAssessments,
	CustomerAssessmentsResponse,
	UserAnswers,
} from "./src/customer-assessments/customer-assessments.model";
export { customerAssessmentsReducer } from "./src/customer-assessments/customer-assessments.reducer";
export { CustomerAssessmentsSelector } from "./src/customer-assessments/customer-assessments.selector";
export { CustomerAssessmentsService } from "./src/customer-assessments/customer-assessments.service";
export { CustomerVerificationConfigService } from "./src/customer-verification/customer-verification.config";
export { CustomerVerificationGuard } from "./src/customer-verification/customer-verification.guard";
export { VerificationType } from "./src/customer-verification/customer-verification.model";
export { CustomerVerificationService } from "./src/customer-verification/customer-verification.service";
export {
	CookieConsentAction,
	COOKIE_CONSENT_ACTION_TYPE,
} from "./src/data-protection/cookie-consent/cookie-consent.action";
export { CookieConsentConfigService } from "./src/data-protection/cookie-consent/cookie-consent.config";
export {
	cookieConsentAccepted,
	cookieConsentDeclined,
} from "./src/data-protection/cookie-consent/cookie-consent.const";
export { CookieConsentEffect } from "./src/data-protection/cookie-consent/cookie-consent.effect";
export { ConsentCookie, CookieConsentState } from "./src/data-protection/cookie-consent/cookie-consent.model";
export { cookieConsentReducer } from "./src/data-protection/cookie-consent/cookie-consent.reducer";
export { CookieConsentSelector } from "./src/data-protection/cookie-consent/cookie-consent.selector";
export { CookieConsentService } from "./src/data-protection/cookie-consent/cookie-consent.service";
export { CookieSettingsDataProtectionGuard } from "./src/data-protection/cookie-settings/cookie-settings-data-protection.guard";
export { DataProtectionAction } from "./src/data-protection/data-protection.action";
export { DataProtectionConfigService } from "./src/data-protection/data-protection.config";
export { DataProtectionEffect } from "./src/data-protection/data-protection.effect";
export { DataProtectionState } from "./src/data-protection/data-protection.model";
export { dataProtectionReducer } from "./src/data-protection/data-protection.reducer";
export { DataProtectionSelector } from "./src/data-protection/data-protection.selector";
export { DataProtectionService } from "./src/data-protection/data-protection.service";
export {
	MarketingSettingsAction,
	MARKETING_SETTINGS_ACTION_TYPE,
} from "./src/data-protection/marketing-settings/marketing-settings.action";
export * from "./src/data-protection/marketing-settings/marketing-settings.const";
export { MarketingSettingsEffect } from "./src/data-protection/marketing-settings/marketing-settings.effect";
export * from "./src/data-protection/marketing-settings/marketing-settings.model";
export { MarketingSettingsState } from "./src/data-protection/marketing-settings/marketing-settings.model";
export { marketingSettingsReducer } from "./src/data-protection/marketing-settings/marketing-settings.reducer";
export { MarketingSettingsSelector } from "./src/data-protection/marketing-settings/marketing-settings.selector";
export { MarketingSettingsService } from "./src/data-protection/marketing-settings/marketing-settings.service";
export { SubscriptionsDataProtectionGuard } from "./src/data-protection/subscriptions/subscriptions-data-protection.guard";
export { FraudPreventionConfigService } from "./src/fraud-prevention/fraud-prevention.config";
export { CustomerFraudToken, FraudPreventionProvider } from "./src/fraud-prevention/fraud-prevention.model";
export { FraudPreventionService } from "./src/fraud-prevention/fraud-prevention.service";
export { GroupIBFraudPreventionService } from "./src/fraud-prevention/groupib-fraud-prevention.service";
export { IovationFraudPreventionService } from "./src/fraud-prevention/iovation-fraud-prevention.service";
export { ThreatMetrixFraudPreventionService } from "./src/fraud-prevention/threatmetrix-fraud-prevention.service";
export { HampiGuard } from "./src/hampi/hampi.guard";
export { HampiService } from "./src/hampi/hampi.service";
export { HomeContentWidgetAction } from "./src/home-content-widget/home-content-widget.action";
export { HomeContentWidgetEffect } from "./src/home-content-widget/home-content-widget.effect";
export { HomeContentWidget, HomeContentWidgetResponseItem } from "./src/home-content-widget/home-content-widget.model";
export { HomeContentWidgetSelector } from "./src/home-content-widget/home-content-widget.selector";
export { IauiBettingLimitAction } from "./src/iaui-betting-limit/iaui-betting-limit.action";
export { IauiBettingLimitEffect } from "./src/iaui-betting-limit/iaui-betting-limit.effect";
export { IauiBettingLimitSelector } from "./src/iaui-betting-limit/iaui-betting-limit.selector";
export {
	IauiVerificationAction,
	IAUI_VERIFICATION_ACTION_TYPE,
} from "./src/iaui-verification/iaui-verification.action";
export { IauiVerificationSelector } from "./src/iaui-verification/iaui-verification.selector";
export { IosNativeBlockConfigService } from "./src/ios-native-block/ios-native-block.config";
export { IosNativeBlockGuard } from "./src/ios-native-block/ios-native-block.guard";
export { LanguageConfigService } from "./src/language/language.config";
export { LoyaltyContentAction } from "./src/loyalty/loyalty-content/loyalty-content.action";
export {
	LoyaltyEarnPoints,
	LoyaltyEarnPointsItem,
	LoyaltyEarnPointsResponse,
	LoyaltyMemberLevel,
	LoyaltyMemberLevelResponse,
} from "./src/loyalty/loyalty-content/loyalty-content.model";
export { LoyaltyContentSelector } from "./src/loyalty/loyalty-content/loyalty-content.selector";
export { LoyaltyAction, LOYALTY_ACTION_TYPE } from "./src/loyalty/loyalty.action";
export { LoyaltyConfigService } from "./src/loyalty/loyalty.config";
export { LoyaltyGuard } from "./src/loyalty/loyalty.guard";
export {
	LoyaltyBalance,
	LoyaltyHistory,
	LoyaltyHistoryDetail,
	LoyaltyHistoryFilter,
	LoyaltyLevel,
	LoyaltyLevelDetail,
	LoyaltyMonthlyHistory,
	LoyaltyMonthlyHistoryDetail,
	LoyaltyOperationType,
	LoyaltyState,
} from "./src/loyalty/loyalty.model";
export { LoyaltySelector } from "./src/loyalty/loyalty.selector";
export { LoyaltyService } from "./src/loyalty/loyalty.service";
export { SequentialLoyaltyGuard } from "./src/loyalty/sequential-loyalty.guard";
export { MissingPasswordAction } from "./src/missing-password/missing-password.action";
export { MissingPasswordConfigService } from "./src/missing-password/missing-password.config";
export {
	CACHE_STORE_MISSING_PASSWORD,
	MISSING_PASSWORD_MESSAGE_CODES,
	MISSING_PASSWORD_MESSAGE_CONTEXT,
	SKIP_MISSING_PASSWORD_KEY,
} from "./src/missing-password/missing-password.const";
export * from "./src/module";
export { CommonModule } from "./src/module";
export { MoneyModel } from "./src/money/money.model";
export { MyOffersGuard } from "./src/my-offers/my-offers.guard";
export { NationalityAction, NATIONALITY_ACTION_TYPE } from "./src/nationality/nationality.action";
export { Nationality } from "./src/nationality/nationality.model";
export { NationalitySelector } from "./src/nationality/nationality.selector";
export { RegionAction, REGION_ACTION_TYPE } from "./src/region/region.action";
export { Region } from "./src/region/region.model";
export { RegionSelector } from "./src/region/region.selector";
export { NoopOmsService } from "./src/oms/noop/noop-oms.service";
export { OccupationsAction, OCCUPATION_ACTION_TYPE } from "./src/occupations/occupations.action";
export { Occupation } from "./src/occupations/occupations.model";
export { OccupationsSelector } from "./src/occupations/occupations.selector";
export { OmsAction, omsActionType } from "./src/oms/oms.action";
export { OmsConfigService } from "./src/oms/oms.config";
export { omsMessageContext } from "./src/oms/oms.const";
export { OmsEffect } from "./src/oms/oms.effect";
export {
	NotificationsInfo,
	OmsButtonContent,
	OmsImageContent,
	OmsMessage,
	OmsMessageAction,
	OmsMessageContent,
	OmsMessageStatus,
	OmsRoute,
	OmsService,
	OmsState,
	OmsUserSettings,
	UpdateMessage,
} from "./src/oms/oms.model";
export { omsReducer } from "./src/oms/oms.reducer";
export { OmsSelector } from "./src/oms/oms.selector";
export { CoreOmsService } from "./src/oms/oms.service";
export { DepositDetails, PaymentQueryParams, PaymentSettings } from "./src/payment/payment.model";
export {
	PhoneVerificationAction,
	PHONE_VERIFICATION_ACTION_TYPE,
} from "./src/phone-verification/phone-verification.action";
export { PhoneVerificationConfigService } from "./src/phone-verification/phone-verification.config";
export { PhoneVerificationService } from "./src/phone-verification/phone-verification.service";
export { PersonalDataAction, PERSONAL_DATA_ACTION_TYPE } from "./src/personal-data/personal-data.action";
export {
	RequestStatus,
	SarRequestResponse,
	SarRequest,
	SarSubjectId,
	SarRequestType,
} from "./src/personal-data/personal-data.model";
export { PERSONAL_DATA_MESSAGE_CODES } from "./src/personal-data/personal-data.const";
export { PersonalDataSelector } from "./src/personal-data/personal-data.selector";
export { ProductDetectionGuard } from "./src/product-detection/product-detection.guard";
export { ProductLinkAction } from "./src/product-link/product-link.action";
export { ProductLinkEffect } from "./src/product-link/product-link.effect";
export { ProductLink, ProductLinkResponseItem } from "./src/product-link/product-link.model";
export { ProductLinkSelector } from "./src/product-link/product-link.selector";
export { ProductMappingService } from "./src/product-mapping/product-mapping.service";
export { NetLossLimitConfirmationStatus } from "./src/responsible-gaming/betting-limit";
export {
	BettingLimitAction,
	BETTING_LIMIT_ACTION_TYPE,
} from "./src/responsible-gaming/betting-limit/betting-limit.action";
export {
	BalanceLimitAction,
	BALANCE_LIMIT_ACTION_TYPE,
} from "./src/responsible-gaming/balance-limit/balance-limit.action";
export { BALANCE_LIMIT_MESSAGE_CONTEXT } from "./src/responsible-gaming/balance-limit/balance-limit.const";
export { BettingLimitConfigService } from "./src/responsible-gaming/betting-limit/betting-limit.config";
export {
	BETTING_LIMIT_MESSAGE_CONTEXT,
	LIMIT_PERIODS,
} from "./src/responsible-gaming/betting-limit/betting-limit.const";
export { BettingLimitEffect } from "./src/responsible-gaming/betting-limit/betting-limit.effect";
export {
	BettingLimit,
	BettingLimitMessageCodes,
	BettingLimitState,
	BettingLimitType,
	LimitPeriod,
} from "./src/responsible-gaming/betting-limit/betting-limit.model";
export {
	BalanceLimitState,
	BalanceLimitUpdate,
	BalanceLimit,
} from "./src/responsible-gaming/balance-limit/balance-limit.model";
export { bettingLimitReducer } from "./src/responsible-gaming/betting-limit/betting-limit.reducer";
export { BettingLimitSelector } from "./src/responsible-gaming/betting-limit/betting-limit.selector";
export { BalanceLimitSelector } from "./src/responsible-gaming/balance-limit/balance-limit.selector";
export { BettingLimitService } from "./src/responsible-gaming/betting-limit/betting-limit.service";
export {
	getNetlossLimitConfirmation,
	getNetlossLimitConfirmationFail,
	getNetlossLimitConfirmationSuccess,
	netLossConfirmationReducer,
	selectBetLimitId,
	selectNetLossConfirmation,
	updateNetLossLimitConfirmation,
	updateNetLossLimitConfirmationFail,
	updateNetLossLimitConfirmationSuccess,
} from "./src/responsible-gaming/betting-limit/netloss-limit-confirmation/";
export { NETLOSS_LIMIT_80_ID } from "./src/responsible-gaming/betting-limit/netloss-limit/netloss-limit.const";
export { netlossLimitReducer } from "./src/responsible-gaming/betting-limit/netloss-limit/netloss-limit.reducer";
export { NetlossLimitSelector } from "./src/responsible-gaming/betting-limit/netloss-limit/netloss-limit.selector";
export { CommonResponsibleGamingSelector } from "./src/responsible-gaming/common-responsible-gaming-selector.service";
export { LogoutCooldownLimitAction } from "./src/responsible-gaming/logout-cooldown-limit/logout-cooldown-limit.action";
export { LOGOUT_COOLDOWN_LIMIT_MESSAGE_CONTEXT } from "./src/responsible-gaming/logout-cooldown-limit/logout-cooldown-limit.const";
export {
	LogoutCooldownLimit,
	LogoutCooldownLimitDelete,
	LogoutCooldownLimitState,
	LogoutCooldownLimitStatus,
	LogoutCooldownLimitUpdate,
} from "./src/responsible-gaming/logout-cooldown-limit/logout-cooldown-limit.model";
export { LogoutCooldownLimitSelector } from "./src/responsible-gaming/logout-cooldown-limit/logout-cooldown-limit.selector";
export {
	LoginLimit,
	LoginLimitRemove,
	LoginLimitState,
	LoginLimitStatus,
	LoginLimitUpdate,
	LoginLimitProgress,
	LoginLimitProgressState,
} from "./src/responsible-gaming/login-limit/login-limit.model";
export { LoginLimitSelector } from "./src/responsible-gaming/login-limit/login-limit.selector";
export { LoginLimitService } from "./src/responsible-gaming/login-limit/login-limit.service";

export {
	MultiSessionLimitAction,
	MULTI_SESSION_LIMIT_ACTION_TYPE,
} from "./src/responsible-gaming/multi-session-limit/multi-session-limit.action";
export { MultiSessionLimitConfigService } from "./src/responsible-gaming/multi-session-limit/multi-session-limit.config";
export {
	MULTI_SESSION_LIMIT_MESSAGE_CODES,
	MULTI_SESSION_LIMIT_MESSAGE_CONTEXT,
} from "./src/responsible-gaming/multi-session-limit/multi-session-limit.const";
export { MultiSessionLimitEffect } from "./src/responsible-gaming/multi-session-limit/multi-session-limit.effect";
export {
	MultiSessionLimit,
	MultiSessionLimitResponse,
	MultiSessionLimits,
	MultiSessionLimitStrings,
} from "./src/responsible-gaming/multi-session-limit/multi-session-limit.model";
export { multiSessionLimitReducer } from "./src/responsible-gaming/multi-session-limit/multi-session-limit.reducer";
export { MultiSessionLimitSelector } from "./src/responsible-gaming/multi-session-limit/multi-session-limit.selector";
export { ZhhSessionLimitAction } from "./src/responsible-gaming/zhh-session-limit/zhh-session-limit.action";
export {
	ZhhSessionLimit,
	ZhhSessionLimitState,
} from "./src/responsible-gaming/zhh-session-limit/zhh-session-limit.model";
export { ZhhSessionLimitSelector } from "./src/responsible-gaming/zhh-session-limit/zhh-session-limit.selector";
export { RewardAction, REWARD_ACTION_TYPE } from "./src/reward/reward.action";
export { RewardConfigService } from "./src/reward/reward.config";
export { REWARD_MESSAGE_CODE, REWARD_MESSAGE_CONTEXT } from "./src/reward/reward.const";
export { RewardEffect } from "./src/reward/reward.effect";
export {
	Reward,
	RewardCategory,
	RewardClaimRequest,
	RewardCount,
	RewardFilter,
	RewardLockupType,
	RewardPayoutStrategy,
	RewardPayoutStrategyType,
	RewardResponse,
	RewardsPayload,
	RewardsResponse,
	RewardState,
	RewardStateFilterType,
	RewardStatePayload,
	RewardStateType,
	RewardTextContent,
	RewardUpdatePayload,
	RewardUpdateRequest,
	RewardUpdateRequestData,
} from "./src/reward/reward.model";
export { rewardReducer } from "./src/reward/reward.reducer";
export { RewardSelector } from "./src/reward/reward.selector";
export { RewardService } from "./src/reward/reward.service";
export { COMMON_ROUTE } from "./src/route";
export {
	SmsNotificationSettingsAction,
	SMS_NOTIFICATION_ACTION_TYPE,
} from "./src/sms-notification-settings/sms-notification-settings.action";
export { SmsNotificationSettingsConfigService } from "./src/sms-notification-settings/sms-notification-settings.config";
export {
	SmsNotificationSettings,
	SmsNotificationSettingsState,
} from "./src/sms-notification-settings/sms-notification-settings.model";
export { SmsNotificationSettingsSelector } from "./src/sms-notification-settings/sms-notification-settings.selector";
export { SmsNotificationSettingsService } from "./src/sms-notification-settings/sms-notification-settings.service";
export { TwoFactorAuthAction } from "./src/two-factor-auth/two-factor-auth.action";
export { TwoFactorAuthService } from "./src/two-factor-auth/two-factor-auth.service";
export {
	twoFactorAuthCodeVerificationErrorDictionary,
	TwoFactorAuthCodeVerificationErrors,
	TwoFactorAuthCodeBEVerificationErrors,
	TwoFactorAuthCodeCommonVerificationErrors,
	TwoFactorAuthDialogStep,
	TwoFactorAuthFlow,
	TwoFactorAuthMethodType,
	TwoFactorAuthRemoveType,
	TwoFactorChallengeType,
} from "./src/two-factor-auth/two-factor-auth.const";
export { TwoFactorAuthConfigService } from "./src/two-factor-auth/two-factor-auth.config";
export { twoFactorAuthReducer } from "./src/two-factor-auth/two-factor-auth.reducer";
export {
	RequestOtpPayload,
	TwoFactorAuthIconDetails,
	TwoFactorAuthState,
	TwoFactorChallengeDetails,
	TwoFactorAuthDevice,
	TwoFactorAuthEnabledMethods,
	TwoFactorVerifyPayload,
} from "./src/two-factor-auth/two-factor-auth.model";
export { TwoFactorAuthSelector } from "./src/two-factor-auth/two-factor-auth.selector";
export { CommonState } from "./src/state";
export { SupportAction, SUPPORT_ACTION_TYPE } from "./src/support/support.action";
export { SupportConfigService } from "./src/support/support.config";
export { SupportEffect } from "./src/support/support.effect";
export { SupportState } from "./src/support/support.model";
export { supportReducer } from "./src/support/support.reducer";
export { SupportSelector } from "./src/support/support.selector";
export { SupportService } from "./src/support/support.service";
export { DataProtectionEventName } from "./src/telemetry/data-protection/data-protection-telemetry.model";
export { CommonTrackingContext } from "./src/telemetry/telemetry.model";
export { interfaceOf } from "./src/utils/comparisons/interface";
export { MissingKeyHandler } from "./src/utils/missing-key-handler";
export { KebabCasePipe } from "./src/utils/pipes/kebab-case.pipe";
export { TakePipe } from "./src/utils/pipes/take.pipe";
export { UserDeviceService } from "./src/utils/services/user-device.service";
export { isEmailValid } from "./src/validators/email/email-validator";
export { TermsAndConditionsConfigService } from "./src/terms-and-conditions/terms-and-conditions.config";
export { CasinoBlockGuard } from "./src/product-block/casino-block.guard";
export { SportBlogGuard } from "./src/sport-blog/sport-blog.guard";
export { ArgentinaGeofencingGuard } from "./src/geofencing/argentina-geofencing.guard";
export { BrazilGeofencingGuard } from "./src/geofencing/brazil-geofencing.guard";
export { AwsGeofencingGuard } from "./src/geofencing/aws-geofencing.guard";
export { AwsGeofencingService } from "./src/geofencing/aws-geofencing.service";
export { GeofencingService } from "./src/geofencing/geofencing.service";
export { GeofencingSelector } from "./src/geofencing/geofencing.selector";
export { GeoFencingAction } from "./src/geofencing/geofencing.action";
export { IpLocationResponse, CountryAreaStatus, GeoFencingErrorType } from "./src/geofencing/geofencing.model";
export { GEOFENCING_ERROR } from "./src/geofencing/geofencing.const";
export { GeofencingGuard } from "./src/geofencing/geofencing.guard";
export { TermsAndConditionsAction } from "./src/terms-and-conditions/terms-and-conditions.action";
export {
	TermsAndConditionsVersion,
	TermsAndConditionsVersionContent,
} from "./src/terms-and-conditions/terms-and-conditions.model";
export { TermsAndConditionsSelector } from "./src/terms-and-conditions/terms-and-conditions.selector";
export { TermsAndConditionsService } from "./src/terms-and-conditions/terms-and-conditions.service";
export { NationalDataAction } from "./src/nationaldata/national-data.action";
export { BirthCity } from "./src/nationaldata/national-data.model";
export { BirthCountry } from "./src/nationaldata/national-data.model";
export { NationalDataSelector } from "./src/nationaldata/national-data.selector";
export { DepositThresholdSelector } from "./src/kcy/deposit-threshold/deposit-threshold.selector";
export { DepositThresholdAction } from "./src/kcy/deposit-threshold/deposit-threshold.action";
export { removeAccents } from "./src/utils/accents/accents.util";

export { CustomerValidationConfig } from "./src/customer-validation/customer-validation.config";
export { KycConfig } from "./src/kcy/kcy.config";
export { AlternativeLayoutConfigService } from "./src/alternative-layout/alternative-layout.config";

export { DepositLimitCalculatorAction } from "./src/responsible-gaming/deposit-limit-calculator/deposit-limit-calculator.action";
export { DepositLimitCalculatorSelector } from "./src/responsible-gaming/deposit-limit-calculator/deposit-limit-calculator.selector";
export { DepositLimitCalculatorConfigService } from "./src/responsible-gaming/deposit-limit-calculator/deposit-limit-calculator-config";
export {
	DepositLimitCalculation,
	DepositLimitCalculationError,
} from "./src/responsible-gaming/deposit-limit-calculator/deposit-limit-calculator.model";
export { DepositLimitCalculatorService } from "./src/responsible-gaming/deposit-limit-calculator/deposit-limit-calculator.service";
export {
	DepositLimitCalculatorPredictionsResponse,
	DepositLimitPrediction,
} from "./src/responsible-gaming/deposit-limit-calculator/deposit-limit-calculator.model";
export {
	DepositLimitPeriods,
	CACHE_STORE_DEPOSIT_LIMIT_CALCULATOR,
	DEPOSIT_LIMIT_CALCULATOR_MESSAGE_CONTEXT,
	DEPOSIT_LIMIT_CALCULATOR_PREDICTIONS_KEY,
	DEPOSIT_LIMIT_CALCULATOR_TRANSLATION_PREFIX,
	DepositLimitCalculatorMethods,
	HOURS_OF_THE_DAY,
	DEFAULT_MAX_DEPOSIT_LIMIT,
} from "./src/responsible-gaming/deposit-limit-calculator/deposit-limit-calculator.const";
export { DepositLimitCalculatorPredictionsQuery } from "./src/responsible-gaming/deposit-limit-calculator/deposit-limit-calculator.model";
export { GeofencingConfigService } from "./src/geofencing/geofencing.config";
export {
	LoginLimitAction,
	LOGIN_LIMIT_PROGRESS_ACTION_TYPE,
} from "./src/responsible-gaming/login-limit/login-limit.action";
export { LOGIN_LIMIT_MESSAGE_CONTEXT } from "./src/responsible-gaming/login-limit/login-limit.const";

export { GAMING_GAME_LAUNCHERS } from "./src/utils/utils.const";

export const COMMON_REDUCER: ActionReducerMap<Partial<CommonState>> = {
	commonContent: commonContentReducer,
	oms: omsReducer,
	support: supportReducer,
	reward: rewardReducer,
	campaign: campaignReducer,
	campaignCustomerOffer: customerOfferStateReducer,
	smsNotification: smsNotificationSettingsReducer,
	blog: blogReducer,
	loyalty: loyaltyReducer,
	loyaltyContent: loyaltyContentReducer,
	bettingLimit: bettingLimitReducer,
	balanceLimit: balanceLimitReducer,
	netlossLimit: netlossLimitReducer,
	logoutCooldownLimit: logoutCooldownLimitReducer,
	depositLimitCalculator: depositLimitCalculatorReducer,
	cookieNotice: rehydrate(cookieNoticeReducer),
	cookieConsent: cookieConsentReducer,
	cashDesk: cashDeskReducer,
	marketingSettings: marketingSettingsReducer,
	dataProtection: dataProtectionReducer,
	multiSessionLimit: multiSessionLimitReducer,
	country: countryReducer,
	customerAssessments: customerAssessmentsReducer,
	homeContentWidget: homeContentWidgetReducer,
	productLink: productLinkReducer,
	callingCode: callingCodeReducer,
	nationality: nationalityReducer,
	region: regionReducer,
	sar: personalDataReducer,
	commonIauiBettingLimit: iauiBettingLimitReducer,
	commonIauIVerification: iauiVerificationReducer,
	netlossLimitConfirmation: netLossConfirmationReducer,
	geofencing: geoFencingReducer,
	termsAndConditions: termsAndConditionsReducer,
	twoFactorAuth: twoFactorAuthReducer,
	occupations: occupationsReducer,
	nationalData: nationalDataReducer,
	depositThreshold: depositThresholdReducer,
	loginLimit: loginLimitReducer,
	loginLimitProgress: loginLimitProgressReducer,
	zhhSessionLimit: zhhSessionLimitReducer,
};

export * from "./src/responsible-gaming/betting-limit";

export { GetCountryStatesResponse } from "./src/country/country.model";
export { GTMConsentStatus, UserConsent } from "./src/data-protection/cookie-consent/cookie-consent.model";
export { ResponsibleGamingUiConfigService } from "./src/responsible-gaming/config";
export { LoginLimitConfigService } from "./src/responsible-gaming/login-limit/login-limit.config";
export { TwoFactorAuthTelemetryService } from "./src/two-factor-auth/two-factor-auth-telemetry.service";

export * from "./src/login/login.const";
export { ZhhSessionLimitConfigService } from "./src/responsible-gaming/zhh-session-limit/zhh-session-limit.config";
export { GameRoundHistoryConfig } from "./src/game-round-history/game-round-history.config";
export { CompleteVerificationGuard } from "./src/complete-verification/complete-verification.guard";
export { NATIONAL_DOCUMENTS } from "./src/national-document/national-document.const";
export {
	NationalDocuments,
	NationalDocument,
	NationalDocumentAuthority,
} from "./src/national-document/national-document.model";
export { OptimizelyDefaultFlag } from "./src/account-settings/account-settings.model";
export {
	CurrentLocationModel,
	GpsLocationModel,
	IpInfoResponse,
} from "./src/geofencing/current-location/current-location.model";
